import ContactIcons from './contact-icons'
export default ContactIcons
